export const FORMLY_FIELD_WRAPPERS = {
	formField: 'form-field',
	section: 'section',
	sectionAccordion: 'section-accordion',
	sectionSimple: 'section-simple',
	sectionSimpleTitle: 'section-simple-title',
	sectionSingleField: 'section-single-field',
	customPanelWithTitle: 'custom-title-panel',
	sectionCard: 'section-card',
	basicWrapper: 'basic-wrapper',
	customWrapper: 'custom-wrapper',
	addons: 'addons',
	plaintext: 'plaintext',
	reportWrapper: 'report-wrapper',
	reportFieldWrapper: 'report-field-wrapper',
	panelDefaultWrapper: 'panel-default-wrapper',
	matCardWrapper: 'mat-card-wrapper',
	matExpansionPanelWrapper: 'mat-expansion-panel-wrapper',
};
